import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "./AdminImage/logo-light-icon.png";
import config from "../../function/config";
import axios from "axios";
import admin from "./AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { format } from "date-fns";


export default function LogisticsApprov() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(5);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size

  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };

  const [allShips, setallShips] = useState([]);
  const [allCategory, setallCategory] = useState([]);
  const [allSubCategory, setallSubCategory] = useState([]);
  const [input, setInput] = useState([]);
  const [count, setCount] = useState(0);

 

  // fetch ship data
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewLogistics`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              search: input,
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setallShips(res1.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, input, count]);



  const navigate = useNavigate();

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${config.base_url}/api/HappyMarineShipping/deleteLogistic/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setCount(id);
        console.log(response);
        toast.success(" Deleted Successfully !", {
          autoClose: 1000,
          position: "top-right",
        });
      } else {
        console.log("error1");
        toast.error("Error", {
          autoClose: 2000,
          position: "top-right",
        });
      }
    } catch (err) {
      console.log("error2", err);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };

  const token = localStorage.getItem('Token')


  const handleStatus = async (id)=>{
      const data={
      }
      try {
          const response = await axios.put(`${config.base_url}/api/HappyMarineShipping/allow/logistics/${id}`, data, {
             
          });
  
          if (response.data.status === 200) {
             console.log("Success")
             setCount(count +1)
              toast.success("Approved",{
                         autoClose:1500,
                         position:'top-right',
                         
                       });
          } else {
              console.log("Error while marking as completed");
          }
      } catch (err) {
          console.log("Error:", err);
      }
  }


  const handleStatusD = async (id)=>{
    const data={
    }
    try {
        const response = await axios.put(`${config.base_url}/api/HappyMarineShipping/deny/logistics/${id}`, data, {
            headers: {
                'Authorization': `Token ${token}`
            }
        });
  
        if (response.data.status === 200) {
           console.log("Success")
           setCount(count +1)
            toast.success(" Rejected!",{
                       autoClose:1500,
                       position:'top-right',
                       
                     });
        } else {
            console.log("Error while marking as completed");
        }
    } catch (err) {
        console.log("Error:", err);
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);


  const [newShip, setNewShip] = useState(
  JSON.parse(localStorage.getItem("newShip")) || false
);
const [prevShipCount, setPrevShipCount] = useState(
  JSON.parse(localStorage.getItem("prevShipCount")) || 0
);

const handleView = () => {
  setNewShip(false);
  localStorage.setItem("newShip", JSON.stringify(false));
  setPrevShipCount(allShips.length);
  localStorage.setItem("prevShipCount", JSON.stringify(allShips.length));
};


const [allImages,setallImages] = useState([])
     
      
     useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images_CReg`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res3.data.status === 200) {
          console.log("All Images Fetched:", res3.data.data); // ✅ Add this line
          setallImages(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);



  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* Left Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

        {/* Menu Button (Moves on Sidebar Toggle) */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-60" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>
        {/* mobile screen menu button */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:block hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-32" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>

        {/* Admin Profile  (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
          {/* notification */}
          
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={'/admin/profile'}>Profile</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
                      <div
                        className={`${
                          isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
                        }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
                      >
                        <ul className="mt-10 flex flex-col gap-3 ">
                          {/* Dashboard */}
                          <li className="px-4 py-2 text-lg   flex items-center">
                            <i className="fa-solid fa-gauge mr-3"></i>
                            {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
                          </li>
              
                          {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
              
                          {/* Ship For Sale Dropdown */}
                          <li className="px-2   text-lg  flex flex-col  relative">
                            <div
                              className="flex items-center  justify-between cursor-pointer p-2"
                              onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                            >
                              <div className="flex items-center  gap-2 hover:text-[#00c292]">
                               <h1 className="text-xl text-center font-semibold">-</h1>
                                {isSidebarOpen && <span>Ship For Sale</span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
              
                            {!isSidebarOpen && openDropdown === 1 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                <ul>
                                  <li className="px-4 py-1 hover:text-[#00c292]">
                                    <Link to="/admin/addShip">Add Ships</Link>
                                  </li>
                                  <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                    <Link to="/admin/viewShip">View Ships</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Dropdown Content */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 1
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-4 py-1 hover:text-[#00c292]">
                                    <Link to="/admin/addShip">Add Ships</Link>
                                  </li>
                                  <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                                    <Link to="/admin/viewShip">View Ships</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
              
                          <li className="px-2  text-lg  flex flex-col relative">
                            <div
                              className="flex items-center justify-between cursor-pointer p-2"
                              onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                            >
                              <div className="flex items-center hover:text-[#00c292] gap-2">
                                <h1 className="text-xl text-center font-semibold">-</h1>
                                {isSidebarOpen && <span>Ship For Charter</span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
                            {!isSidebarOpen && openDropdown === 2 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                <ul>
                                  <li className="px-1 py-1 text-[#8D97AD] w-full hover:text-[#00c292]">
                                    <Link to="/admin/addCharter">Add Charter</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full  hover:text-[#00c292]">
                                    <Link to="/admin/shipforCharter">View Charter</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Dropdown Content */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 2
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                    <Link to="/admin/addCharter">Add Charter</Link>
                                  </li>
                                  <li className="px-4 py-1  hover:text-[#00c292]">
                                    <Link to="/admin/shipforCharter">View Charter</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
              
                           <li className="px-2  text-lg flex flex-col relative group ">
                            <div
                              className="flex items-center justify-between cursor-pointer p-2"
                              onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                            >
                              <div className="flex items-center hover:text-[#00c292] gap-2">
                                 <h1 className="text-xl text-center font-semibold">-</h1>
                                {isSidebarOpen && <span>Open Cargo </span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
              
                            {!isSidebarOpen && openDropdown === 3 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                <ul>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to='/admin/addcargo'>Add Cargo</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to='/admin/viewCargo' >View Cargo</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Dropdown Content */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 3
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to='/admin/addcargo'>Add Cargo</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to='/admin/viewCargo' >View Cargo</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
              
                          <li className="px-2  text-lg flex flex-col relative group ">
                            <div
                              className="flex items-center justify-between cursor-pointer p-2"
                              onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                            >
                              <div className="flex items-center hover:text-[#00c292] gap-2">
                                 <h1 className="text-xl text-center font-semibold">-</h1>
                                {isSidebarOpen && <span>Supply Equipments </span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
              
                            {!isSidebarOpen && openDropdown === 4 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                <ul>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                    <Link to="/admin/addsEq">Add Equipments</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                    <Link to="/admin/shipforEq">View Equipments</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Dropdown Content */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 4
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                    <Link to="/admin/addsEq">Add Equipments</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                    <Link to="/admin/shipforEq">View Equipments</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
              
                           
                         {isSidebarOpen && (
                                        <div className="px-5 mt-2 w-[75%]">
                                          <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                                            Approvals
                                          </h1>
                                        </div>
                                      )}
                                      {isSidebarOpen && (
                                        <ul className="px-2  text-lg flex flex-col relative group">
                                          <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforsale"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Ships For Sale
                                            </Link>
                                            {newShip && (
                                              <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                New
                                              </span>
                                            )}
                                          </li>
                          
                                          <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforCharterApp"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Ship For Charter
                                            </Link>
                                          </li>
                          
                                          <li className="px-1 py-2 text-[#00c292]  flex justify-between items-center">
                                            <Link
                                            to='/admin/LogisticsAppr'
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Open Cargo
                                            </Link>
                                          </li>
                          
                                          <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforEqApp"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Supply Equipments
                                            </Link>
                                          </li>
                                        </ul>
                                      )}
              
                          {/* Settings Dropdown */}
                          <li className="px-3 py-2 text-lg flex flex-col relative group">
                            <div
                              className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                              onClick={() => toggleDropdown(6)}
                            >
                              <div className="flex items-center gap-2">
                                <i className="fa-solid fa-gear"></i>
                                {isSidebarOpen && <span>Settings</span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
              
                            {/* Hover Dropdown (Closed Sidebar) */}
                            {!isSidebarOpen && openDropdown === 6 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                                <ul>
                                  <li className="px-4 py-2 hover:bg-gray-100">
                                    <Link to="/admin/profile">Profile</Link>
                                  </li>
                                  <li className="px-4 py-2 hover:bg-gray-100">
                                  <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Click Dropdown (Open Sidebar) */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 6
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-4 py-1 hover:text-[#00c292]">
                                    <Link to="/admin/profile">Profile</Link>
                                  </li>
                                  <li className="px-3 py-1 hover:text-[#00c292]">
                                   <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
                        </ul>
                      </div>
              
                      {/* mobile screen sidebar */}
              
                      <div
                        className={`fixed hidden xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
                          isMobile
                            ? isSidebarOpen
                              ? "w-full translate-x-0" // Open in full width on mobile
                              : "-translate-x-full w-0" // Hide sidebar on mobile
                            : isSidebarOpen
                            ? "w-60 translate-x-0" // Open normally on desktop
                            : "w-0" // Hide sidebar on desktop
                        }`}
                      >
                        <ul className="mt-10 flex flex-col gap-3 ">
                          {/* Dashboard */}
                          <li className={`px-4 py-2 text-lg    flex items-center`}>
                            {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
                            {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
                          </li>
              {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
                          {/* Ship For Sale Dropdown */}
                          <li
                            className={`px-2  text-lg  flex flex-col  relative`}
                          >
                            <div
                              className="flex items-center  justify-between cursor-pointer p-2"
                              onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                            >
                              <div className="flex items-center  gap-2 hover:text-[#00c292]">
                                {isSidebarOpen && <h1 className="text-xl text-center font-semibold">-</h1>}
                                {isSidebarOpen && <span>Ship For Sale</span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
              
                            {!isSidebarOpen && openDropdown === 1 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                <ul>
                                  <li className="px-4 py-1 hover:text-[#00c292]">
                                    <Link to="/admin/addShip">Add Ships</Link>
                                  </li>
                                  <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                    <Link to="/admin/viewShip">View Ships</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Dropdown Content */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 1
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-4 py-1 hover:text-[#00c292]">
                                    <Link to="/admin/addShip">Add Ships</Link>
                                  </li>
                                  <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                                    <Link to="/admin/viewShip">View Ships</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
              
                          <li className="px-3  text-lg flex flex-col relative">
                            <div
                              className="flex items-center justify-between cursor-pointer p-2"
                              onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                            >
                              <div className="flex items-center hover:text-[#00c292] gap-2">
                                {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                {isSidebarOpen && <span>Ship For Charter</span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
                            {!isSidebarOpen && openDropdown === 2 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                <ul>
                                  <li className="px-1 py-1 text-[#8D97AD] w-full hover:text-[#00c292]">
                                    <Link to="/admin/addCharter">Add Charter</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full  hover:text-[#00c292]">
                                    <Link to="/admin/shipforCharter">View Charter</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Dropdown Content */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 2
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                    <Link to="/admin/addCharter">Add Charter</Link>
                                  </li>
                                  <li className="px-4 py-1 hover:text-[#00c292]">
                                    <Link to="/admin/shipforCharter">View Charter</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
              
                           <li className="px-3 text-lg flex flex-col relative group ">
                            <div
                              className="flex items-center justify-between cursor-pointer p-2"
                              onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                            >
                              <div className="flex items-center hover:text-[#00c292] gap-2">
                                {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                {isSidebarOpen && <span>Open Cargo</span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
              
                            {!isSidebarOpen && openDropdown === 3 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                <ul>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to='/admin/addcargo'>Add Cargo</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to='/admin/viewCargo' >View Cargo</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Dropdown Content */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 3
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to='/admin/addcargo'>Add Cargo</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to='/admin/viewCargo' >View Cargo</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
              
                          <li className="px-3  text-lg flex flex-col relative group ">
                            <div
                              className="flex items-center justify-between cursor-pointer p-2"
                              onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                            >
                              <div className="flex items-center hover:text-[#00c292] gap-2">
                                {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                {isSidebarOpen && <span>Supply Equipments</span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
              
                            {!isSidebarOpen && openDropdown === 4 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                <ul>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                    <Link to="/admin/addsEq">Add Equipments</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                    <Link to="/admin/shipforEq">View Equipments</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Dropdown Content */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 4
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                    <Link to="/admin/addsEq">Add Equipments</Link>
                                  </li>
                                  <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                    <Link to="/admin/shipforEq">View Equipments</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
              
                          <li className="px-3 text-lg flex flex-col relative group">
                                                   {/* Clickable Div */}
                                                   {isSidebarOpen && (
                                                     <div className="px-5  w-[50%]">
                                                       <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                                                         Approvals
                                                       </h1>
                                                     </div>
                                                   )}
                                     
                                                   {isSidebarOpen && (
                                                     <ul
                                                       className="px-2 py-2  text-lg flex gap-3
                                                                                                                    flex-col relative group"
                                                     >
                                                       <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforsale"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Ships For Sale
                                                         </Link>
                                                         {newShip && (
                                                           <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                             New
                                                           </span>
                                                         )}
                                                       </li>
                                     
                                                       <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforCharterApp"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Ship For Charter
                                                         </Link>
                                                       </li>
                                     
                                                       <li className="px-1 py-2 text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                         to='/admin/LogisticsAppr'
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Open Cargo
                                                         </Link>
                                                       </li>
                                     
                                                       <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforEqApp"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Supply Equipments
                                                         </Link>
                                                       </li>
                                                     </ul>
                                                   )}
                                     
                                                   {/* Click Dropdown (For open sidebar) */}
                                                   {isSidebarOpen && (
                                                     <div
                                                       className={`ml-6 mt-2 transition-all duration-300 ${
                                                         openDropdown === 5
                                                           ? "max-h-48 opacity-100 "
                                                           : "max-h-0 opacity-0 overflow-hidden"
                                                       }`}
                                                     >
                                                       <ul>
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforsale"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Ships For Sale
                                                           </Link>
                                                           {newShip && (
                                                             <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                               New
                                                             </span>
                                                           )}
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforCharterApp"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Ship For Charter
                                                           </Link>
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                           to='/admin/LogisticsAppr'
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Open Cargo
                                                           </Link>
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforEqApp"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Supply Equipments
                                                           </Link>
                                                         </li>
                                                       </ul>
                                                     </div>
                                                   )}
                                                 </li>
               
              
              
                          {/* Settings Dropdown */}
                          <li className="px-3 py-2 text-lg flex flex-col relative group">
                            <div
                              className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                              onClick={() => toggleDropdown(6)}
                            >
                              <div className="flex items-center gap-2">
                                {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                                {isSidebarOpen && <span>Settings</span>}
                              </div>
                              {isSidebarOpen && (
                                <i
                                  className={`fa-solid ${
                                    openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                                  }`}
                                ></i>
                              )}
                            </div>
              
                            {/* Hover Dropdown (Closed Sidebar) */}
                            {!isSidebarOpen && openDropdown === 6 && (
                              <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                                <ul>
                                  <li className="px-4 py-2 hover:bg-gray-100">
                                    <Link to="/admin/profile">Profile</Link>
                                  </li>
                                  <li className="px-3 py-1 hover:text-[#00c292]">
                                   <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
              
                            {/* Click Dropdown (Open Sidebar) */}
                            {isSidebarOpen && (
                              <div
                                className={`ml-6 mt-2 transition-all duration-300 ${
                                  openDropdown === 6
                                    ? "max-h-40 opacity-100"
                                    : "max-h-0 opacity-0 overflow-hidden"
                                }`}
                              >
                                <ul>
                                  <li className="px-4 py-1 hover:text-[#00c292]">
                                    <Link to="/admin/profile">Profile</Link>
                                  </li>
                                  <li className="px-3 py-1 hover:text-[#00c292]">
                                   <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </li>
                        </ul>
                      </div>

        {/* Main Content */}
        <div className="flex-1 overflow-auto py-4">
          <div className="bg-white  shadow-sm text-xl w-full p-5">
            <div className="flex justify-between items-center">
              <h1>View Details</h1>
              <div className="flex text-sm gap-2">
                <Link to={'/adminHome'}>Home</Link> <span>/</span>
                <p className="text-[#00c292]">View Ship For Open Cargo Registration</p>
              </div>
            </div>
          </div>

          <div className="w-full  py-5 px-4">
            <div className="bg-white overflow-auto w-full max-w-full  p-6 mt-5 rounded">
              <div className="py-3">
                <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Search"
                  className="rounded-lg  sm:w-[50%] w-[20%] p-2 border shadow"
                />
              </div>

              {/* Responsive Table Wrapper */}
              <div className="w-full lg:w-[1500px] shadow-lg rounded-lg overflow-auto">
                <table className=" w-full  bg-white  shadow-lg rounded-lg overflow-auto">
                   <thead className="bg-gray-100 border-b border-gray-200">
                    <tr>
                      <th className="px-4 py-3 text-center text-gray-600 min-w-[150px]">
                        Created At
                      </th>
                      <th className="px-4 py-3 text-center text-gray-600 min-w-[150px]">
                        Type Of Cargo 
                      </th>
                      <th className="px-4 py-3 text-center text-gray-600 min-w-[100px]">
                        Loading Port
                      </th>
                      <th className="px-4 py-3 text-center text-gray-600 min-w-[100px]">
                        Discharge port
                      </th>
                      <th className="px-4 py-3 text-center text-gray-600 ">
                        Tonnage
                      </th>
                      <th className="px-4 py-3 text-center text-gray-600">
                        Contact Info
                      </th>

                       <th className="px-4 py-3 text-center text-gray-600 min-w-[100px]">
                        Status
                      </th>
                      
                      {/* <th className="px-4 py-3 text-center text-gray-600 min-w-[200px]">
                        Image
                      </th> */}
                      <th className="px-4 py-3 text-center text-gray-600 ">
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {allShips.length === 0 ? (
                      <tr>
                        <td
                          colSpan="6"
                          className="px-6 text-red-500 text-center py-4"
                        >
                          Unavailable
                        </td>
                      </tr>
                    ) : (
                      allShips.filter((ship) => ship.is_status === false) .map((item, index) => {
                        const shipImageObj = allImages.find(
      (img) => img.charter === item.id && img.image !== null
    );

    const imageUrl = shipImageObj?.image;
                        return (
                          <tr>
                            <td className="px-4 py-4 text-center text-gray-600 ">
                              {format(new Date(item.created_at), 'MMM dd, yyyy, hh:mm a')}
                            </td>
                            <td className="px-6 py-4 text-center text-gray-600 min-w-[150px]">
                              {item.type_of_cargo}
                            </td>
                            <td className="px-6 py-4 text-center text-gray-600 min-w-[100px]">
                              {item.loading_port}
                            </td>
                            <td className="px-6 py-4 text-center text-gray-600 min-w-[100px]">
                              {item.discharge_port}
                            </td>
                            <td className="px-6 py-4 text-center text-gray-600">
                              {item.tonnage}
                            </td>
                            <td className="px-6 py-4 text-center text-gray-600 ">
                              {item.email},{item.phone}
                            </td>
                            
                            <td className="py-5 flex flex-col px-3 text-center min-w-[150px]">
        {item.is_status===false?(
          <button onClick={(e)=>{e.preventDefault();handleStatus(item.id)}} className="bg-[#00c292] transition-all duration-300 hover:bg-[#246656] rounded px-2 py-1 text-white">
          Approve
        </button>
          
        ):(
          <button onClick={(e)=>{e.preventDefault();handleStatusD(item.id)}} className="bg-red-500 transition-all duration-300 hover:bg-red-400 rounded px-2 py-1 text-white" >
          Reject
        </button>
        )}
        
       {item.url_new && item.url_new.trim() !== "" && (
    <button
      onClick={() => window.open(item.url_new, "_blank")}
      className="bg-blue-600 mt-1 transition-all duration-300 hover:bg-blue-500 rounded px-2 py-1 text-white"
    >
      Ref Email
    </button>
  )}
      </td>
                            
                            <td className="px-6 py-4 text-center text-gray-600 ">
                              <div className="flex gap-4 sm:gap-8 items-center justify-center">
                                <button
            className="text-blue-500 hover:underline"
            onClick={
              () =>{
                  navigate(`/admin/updateViewLogistic/${item.id}`)
                
                }
              } 
          >
            <i className="fa-solid fa-pen"></i>
          </button>
                                <button
                                  onClick={() => handleDelete(item.id)}
                                  className="text-red-500 hover:underline"
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
